import SelectClassInputContainer from './SelectClassInputContainer';

export default SelectClassInputContainer;
